import { log } from '../utils'

/* eslint-disable default-param-last */

const getInitialState = () => {
  if (window && window.storedData) {
    return JSON.parse(window.storedData)
  }
  return {}
}

const storedDataReducer = (state = getInitialState(), action) => {
  switch (action.type) {
    case 'LOAD_APP_DATA': {
      return action.appData
    }
    case 'SET_DETECTED_LOCALE': {
      log(`setting detected locale: ${action.locale}`)
      return state.locale ? state : ({
        ...state,
        locale: action.locale,
      })
    }
    default:
      return state
  }
}

export const initializeState = () => {
  const storedState = storedDataReducer(getInitialState(), { type: '' })
  log(`InitializedState: locale is set to: ${storedState.locale}`)
}

export default storedDataReducer
